import { useState, useRef, useCallback } from 'react';
import p_nav_previous from '../../Assets/Images/p_nav_previous.svg';
import { singleCartDetails } from '../../Services/api';
import { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import p_down_arrow from '../../Assets/Images/p_down_arrow.svg';
import p_up_arrow from '../../Assets/Images/p_up_arrow.svg';
import PayNowOffCanvas from '../../Components/offCanvas/payNowOffCanvas';
import { IoIosArrowForward } from "react-icons/io";
import { MdWork } from "react-icons/md";
import { IoMdHome } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";
import { CgCloseO } from "react-icons/cg";
import { toast } from "react-toastify";
import { FaRegSquarePlus, FaCircleCheck } from "react-icons/fa6";
import axiosInstance from "../../Services/axios";
import ReactLoading from "react-loading";
import Lottie from "lottie-react";
import SuccessLotie from "./../../Assets/lottieFiles/success.json";
import { getDatabase, ref, onValue, Database } from "firebase/database";
import apply_coupon from "../../Assets/Images/icons/apply_coupon.png"
import success_audio from "../../Assets/Audios/success.mp3"
import { RiEBikeFill } from "react-icons/ri";
import select_circle from "../../Assets/Images/icons/select_rectangle.png"
import unselect_circle from "../../Assets/Images/icons/unselect_rectangle.png"
import un_check_box from "../../Assets/Images/icons/un_check_box.png"
import bell_icon from "../../Assets/Images/icons/bell_icon.png"
import door_icon from "../../Assets/Images/icons/door_icon.png"
import Avoid_call from "../../Assets/Images/icons/avoid_call_icon.png"
import gurard_icon from "../../Assets/Images/icons/guard_icon.png"
import pet_foot from "../../Assets/Images/icons/pet_foot_icon.png"
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaSquareCheck } from "react-icons/fa6";
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import { FaPlay } from "react-icons/fa";
import { FaPause, FaStop } from "react-icons/fa6";
import { MdDeleteOutline } from "react-icons/md";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { IoMdClose } from "react-icons/io";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import bookingconfirm_img from "./../../Assets/Images/bookingconfirm.png";
import { showToast } from '../../Components/toastConfig/ToastConfig';
import NodeaxiosInstance from '../../Services/nodeaxios';



const ReviewAndPay = () => {
    const locationModalRef = useRef(null);
    const doorstepReqModalRef = useRef(null);
    const paymentSuccessModalRef = useRef(null);
    const instructionsNoteRef = useRef(null)

    const navigate = useNavigate(); // Navigation hook
    const valueParam = useParams(); // URL parameter hook

    const location = useLocation();
    const { fromPage } = location.state || {};

    const [showMoreInforUser, setShowMoreInforUser] = useState(false);
    const [showMoreInforStaff, setShowMoreInforStaff] = useState(false);
    const [showMoreInforBillingInfo, setShowMoreInforBillingInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [cartDetail, setCartDetail] = useState('');
    const [isLocationListOffCanvasOpen, setLocationListOffCanvasOpen] = useState(false);
    const [isPayNowOffCanvasOpen, setPayNowOffCanvasOpen] = useState(true);
    const [selectedPaymentOption, setSelectedPaymentOption] = useState();
    const [amountToPay, setAmountToPay] = useState('');
    const [showPaymentSuccessModal, setShowPaymentSuccessModal] = useState(false);
    const [userLocation, setUserLocation] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);
    const [offerServiceRedeemStatus, setofferServiceRedeemStatus] = useState()
    const [loyaltyPoints, setLoyaltyPoints] = useState()
    const [booking_ID, setBooking_ID] = useState('')
    const [recordedAudio, setRecordedAudio] = useState(null);
    const [pauseicon, setPauseicon] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [audioDuration, setAudioDuration] = useState(null);
    const [restartRecord, setRestartRecord] = useState(true);
    const [recordedAudioUrl, setRecordedAudioUrl] = useState(null);
    const [oldrecordedAudioblob, setOldRecordedAudioblob] = useState(null);
    const audioRef = useRef(null);

    const [recordingTime, setRecordingTime] = useState(0);
    const timerRef = useRef(null);
    const [consulation, setConsulation] = useState("");

    const [cartId, setCartId] = useState("");
    const [vendorId, setVendorId] = useState("");
    const handlePaySuccessClose = () => setShowPaymentSuccessModal(false);
    const handlePaySuccessShow = () => setShowPaymentSuccessModal(true);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [deliverytipamt, setDeliveryTipamt] = useState(0)
    const [instructionsOption, setInstructionsOption] = useState([])
    const [additionalNotes, setAdditionalNotes] = useState("");
    const [restart_Modal, setRestart_Modal] = useState(false)
    const [vendorType, setVendorType] = useState()
    const [selectedTexts, setSelectedTexts] = useState("")
    const paymentAudio = new Audio(success_audio);
    const [pageLoaded, setPageLoaded] = useState(false);

    // Fetch vendor staff list on component mount
    useEffect(() => {
        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
        if (!localServiceDetail.cart_app_id) {
            navigate('/', { replace: true });
        }
        if (localServiceDetail.cart_app_id) {
            getSingleCartDetails();
            let offer_redeem_status = localServiceDetail.offer_status ? localServiceDetail.offer_status : '';
            let loyalty_redeem_points = localServiceDetail.loyalty_points ? localServiceDetail.loyalty_points : '';
            setLoyaltyPoints(loyalty_redeem_points)
            setofferServiceRedeemStatus(offer_redeem_status)
        }

        let SelectedPaytype = localStorage.getItem('seletedPayType')
        setSelectedPaymentOption(SelectedPaytype ? SelectedPaytype : '1')
    }, []);

    // Function to fetch vendor staff list
    function getSingleCartDetails() {
        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';


        setCartId(localServiceDetail.cart_app_id)

        let param = {
            "vendor_id": valueParam.vendor_id,
            "cart_app_id": localServiceDetail.cart_app_id,
            "service_type": localServiceDetail?.serviceType ? localServiceDetail?.serviceType : '',
        };

        singleCartDetails(param).then((res) => {
            if (res.data) {

                setCartDetail(res.data);
                if (res.data.edit_service_status == 1) {
                    setBooking_ID(res.data.cart_app_id)
                }
                const bookingServiceType = res.data.booking_service_type;
                const serviceLocationStatus = res.data.service_location_status;
                if (bookingServiceType == 2 && serviceLocationStatus == 0) {
                    getuserlocationlist('1');
                }
                setPageLoaded(true)
            } else {
                console.error("Response data is undefined.");
            }
        }).catch((err) => {
            if (err.response) {
                const status = err.response.status;
                const errorMessage = err.response.data?.message || "An error occurred.";
                toast(errorMessage, {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
            } else {
                console.error("Error response is undefined.");
            }
        });

    }

    useEffect(() => {
        const savedOptions = JSON.parse(localStorage.getItem("deliveryInstructions")) || [];
        setInstructionsOption(savedOptions);
        setSelectedTexts(savedOptions); // keep both in sync if needed 
        const additionalNotes = localStorage.getItem("additionalNotes") || "";

        setConsulation(additionalNotes)
    }, []);


    const handelBack = () => {
        const servicetimeRaw = localStorage.getItem("localStorageserviceTime");
        if (!servicetimeRaw) {
            return;
        }

        const servicetime = JSON.parse(servicetimeRaw);

        const updatedStorageData = {
            date: servicetime.date,
            day: servicetime.day,
            time: servicetime.time,
            section: servicetime.section,
            slot: servicetime.slot,
            status: true
        };

        localStorage.setItem("localStorageserviceTime", JSON.stringify(updatedStorageData));
        navigate(-1);
    };


    // Function to toggle review and confirm offcanvas visibility
    const toggleLocationListOffCanvas = () => {
        setLocationListOffCanvasOpen(!isLocationListOffCanvasOpen);
    };

    const togglePayNowOffCanvas = () => {
        // setPayNowOffCanvasOpen(!isPayNowOffCanvasOpen);
        handlePaySuccessShow();
    };

    // Offer type 4: offer price + platform charges + GST (SGST/CGST) + round off
    const getOfferType4Total = () => {
        const pd = cartDetail?.payment_details;
        const gst = cartDetail?.GST_status == 1
            ? Number(pd?.SGST_amount || 0) + Number(pd?.CGST_amount || 0)
            : 0;
        return Number(cartDetail?.applied_card_detail?.offer_price || 0)
            + Number(pd?.user_platform_charges || 0)
            + gst
            + Number(pd?.round_of || 0);
    };

    const handleOptionChange = (event) => {
        localStorage.setItem('seletedPayType', event.target.value)
        setSelectedPaymentOption(event.target.value);

        if (event.target.value == '1') {
            setAmountToPay(cartDetail.payment_details?.total_amount)
        }
    };


    const openLocationModal = () => {
        locationModalRef.current.classList.add("show");
        locationModalRef.current.style.display = "block";
        setIsModalOpen(true)
    };

    const closeLocationModal = () => {
        locationModalRef.current.classList.remove("show");
        setIsModalOpen(false)

    };

    const openDoorReqModal = () => {
        doorstepReqModalRef.current.classList.add("show");
        doorstepReqModalRef.current.style.display = "block";
        setIsModalOpen(true)

    };

    const closeDoorReqModal = () => {
        doorstepReqModalRef.current.classList.remove("show");
        setIsModalOpen(false)

    };

    const openPaySuccessModal = () => {
        // paymentSuccessModalRef.current.classList.add("show");
        // paymentSuccessModalRef.current.style.display = "block";
        paymentAudio.play().catch((error) => console.error("Error playing audio:", error));
    };

    const closePaySuccessModal = () => {
        paymentSuccessModalRef.current.classList.remove("show");
        setIsModalOpen(false)

    };

    const openinstructionsModal = () => {
        instructionsNoteRef.current.classList.add("show");
        instructionsNoteRef.current.style.display = "block";
        setIsModalOpen(true)
    };
    const closeinstructionsModal = () => {
        instructionsNoteRef.current.classList.remove("show");
        instructionsNoteRef.current.style.display = "none";
        setIsModalOpen(false)

    };

    const getuserlocationlist = () => {
        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
        let vendor_id = localServiceDetail.vendorId ? localServiceDetail.vendorId : '';
        let cart_id = localServiceDetail.cart_app_id ? localServiceDetail.cart_app_id : '';
        let service_type = localServiceDetail.serviceType ? localServiceDetail.serviceType : '';
        setLocationLoading(true)
        try {
            let reqData = {
                vendor_id: vendor_id,
                cart_app_id: cart_id,
                service_type: service_type,
            };
            NodeaxiosInstance.post("service/user-locations-list", reqData)
                .then((res) => {
                    setUserLocation(res.data);
                    openLocationModal()
                    setLocationLoading(false)
                }).catch((err) => {

                    const errorMessage = err.response.message || "An error occurred.";
                    toast(errorMessage, {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                });
        } catch {
            const errorMessage = "An error occurred.";
            toast(errorMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: 'text-danger toast-style-1'
            });
        }
    };

    const select_Location = (latlng) => {
        try {
            let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
            let vendor_id = localServiceDetail.vendorId ? localServiceDetail.vendorId : '';
            let cart_id = localServiceDetail.cart_app_id ? localServiceDetail.cart_app_id : '';
            let service_type = localServiceDetail.serviceType ? localServiceDetail.serviceType : '';

            let reqData = {
                "vendor_id": vendor_id,
                "cart_app_id": cart_id,
                "service_type": service_type,
                "location": latlng
            };
            NodeaxiosInstance.post("service/select-location", reqData)
                .then((res) => {

                    closeLocationModal();
                    getSingleCartDetails()
                    // setConfirmlocation(1);
                    // getselectProductDetail();
                })
                .catch((err) => {
                    const errorMessage = err.response?.data?.message || "An error occurred. Please try again.";
                    toast(errorMessage, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: "text-danger toast-style-1"
                    });
                });
        } catch (error) {
            toast('An error occurred. Please try again.', {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: 'text-danger toast-style-1'
            });
        }
    };

    const sent_doorstep_service_request = async () => {
        setIsLoading(true);
        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
        let vendor_id = localServiceDetail.vendorId ? localServiceDetail.vendorId : '';
        let cart_id = localServiceDetail.cart_app_id ? localServiceDetail.cart_app_id : '';
        let service_type = localServiceDetail.serviceType ? localServiceDetail.serviceType : '';

        let data = {
            cart_app_id: cart_id,
            service_type: service_type
        };
        await axiosInstance
            .post("user/sent_doorstep_service_request", data)
            .then((res) => {
                if (res.status == 200) {

                    openDoorReqModal()
                    // setSendRequestModelONOFF(true)
                    // setSendRequestBtnLoader(false)
                }
            })
            .catch((err) => {
                const errorMessage = err.response?.data?.message || "An error occurred. Please try again.";
                toast(errorMessage, {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    className: "text-danger toast-style-1"
                });
            });
    }

    const handleOptionToggle = (label) => {
        setInstructionsOption((prevOptions) => {
            const updatedOptions = prevOptions.includes(label)
                ? prevOptions.filter((option) => option !== label)
                : [...prevOptions, label];

            // Save to localStorage
            localStorage.setItem("deliveryInstructions", JSON.stringify(updatedOptions));

            return updatedOptions;
        });

        // If you also need selectedTexts separately
        setSelectedTexts((prevOptions) =>
            prevOptions.includes(label)
                ? prevOptions.filter((option) => option !== label)
                : [...prevOptions, label]
        );
    };


    const recorderControls = useAudioRecorder(
        {
            noiseSuppression: true,
            echoCancellation: true,
        },
        (err) => console.error(err)
    );

    useEffect(() => {
        if (pauseicon) {
            timerRef.current = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);
        } else {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        return () => clearInterval(timerRef.current);
    }, [pauseicon]);

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, "0");
        const s = (seconds % 60).toString().padStart(2, "0");
        return `${m}:${s}`;
    };

    const addAudioElement = (blob) => {
        if (!blob || (recordedAudio && recordedAudio.size === blob.size)) {

            return;
        }

        if (oldrecordedAudioblob !== blob) {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.src = "";
                audioRef.current.onended = null;
                audioRef.current = null;
            }

            setOldRecordedAudioblob(blob);
            if (recordedAudioUrl) {
                URL.revokeObjectURL(recordedAudioUrl);
            }


            const newAudioUrl = URL.createObjectURL(blob);
            const newAudio = new Audio(newAudioUrl);

            audioRef.current = newAudio;
            audioRef.current.onended = () => {
                setIsPlaying(false);
            };
            setAudioFile(blob);
            setRecordedAudio(blob);
            setRecordedAudioUrl(newAudioUrl);
            setPauseicon(false);
            setRestartRecord(false);
            setIsPlaying(false); // Reset play state for new recording



            newAudio.onloadedmetadata = () => {
                localStorage.setItem("recordedAudioUrl", newAudioUrl);
                localStorage.setItem("audioDuration", recordingTime);
            };

            // ✅ Convert blob to Base64 & save in localStorage
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64data = reader.result;
                const newAudioUrl = URL.createObjectURL(blob);
                localStorage.setItem("recordedAudio", base64data);

            };
            reader.readAsDataURL(blob);
        }
    };

    const [oldRecordurl, setOldRecordurl] = useState('')
    useEffect(() => {
        const savedAudio = localStorage.getItem("recordedAudio");

        if (savedAudio) {
            const audio = new Audio(savedAudio);
            audioRef.current = audio;
            setOldRecordurl(savedAudio); // in case you’re using url state
        }

        const storedDuration = localStorage.getItem("audioDuration");

        if (savedAudio) {
            const newAudio = new Audio(savedAudio);
            audioRef.current = newAudio;
            newAudio.onended = () => setIsPlaying(false);
            setRecordingTime(storedDuration);
            setRecordedAudioUrl(savedAudio);
            setRestartRecord(false);
            setPauseicon(false);
            setIsPlaying(false);

            newAudio.onloadedmetadata = () => {
                setAudioDuration(newAudio.duration.toFixed(2));
            };
        }
    }, []);



    const togglePlayAudio = () => {
        if (!audioRef.current) return;

        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play()
                .catch(e => console.error("Playback failed:", e));
        }
        setIsPlaying(!isPlaying);
    };


    const deleteRecordedAudio = useCallback(() => {

        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.src = "";
            audioRef.current.onended = null;
            audioRef.current = null;
        }


        if (recordedAudioUrl) {
            URL.revokeObjectURL(recordedAudioUrl);
        }

        setRecordedAudio(null);
        setRecordedAudioUrl(null);
        setAudioDuration(null);
        setIsPlaying(false);
        setPauseicon(false);

        setRestartRecord(true);
        setTimeout(() => setRestartRecord(true), 0);
        setRecordingTime(0);
        localStorage.removeItem("recordedAudio");
        localStorage.removeItem("audioDuration");
    }, [recordedAudioUrl]);

    const [audioFile, setAudioFile] = useState()
    const [voiceUrl, setVoiceUrl] = useState()



    const ffmpeg = new FFmpeg();

    const convertToMp4 = async (audioBlob) => {
        if (!ffmpeg.loaded) await ffmpeg.load();

        const buffer = await audioBlob.arrayBuffer();
        const uint8Array = new Uint8Array(buffer);

        const inputFile = "input.webm"; // or "input.wav" based on your blob
        const outputFile = "output.mp4";

        await ffmpeg.writeFile(inputFile, uint8Array);
        await ffmpeg.exec(["-i", inputFile, outputFile]);

        const outputData = await ffmpeg.readFile(outputFile);

        return new Blob([outputData], { type: "video/mp4" });
    };



    const handleSave = async () => {
        localStorage.setItem("additionalNotes", consulation);

        if (!recordedAudio) {
            closeinstructionsModal()
            return;
        }

        try {
            const mp4Blob = await convertToMp4(recordedAudio);

            const formData = new FormData();
            formData.append("file", mp4Blob, "audio.mp4");

            const response = await NodeaxiosInstance.post(
                "/product/upload-audio-note",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status == 200) {
                setVoiceUrl(response.data.file_url);
                localStorage.setItem("recoredURL", response.data.file_url);
                closeinstructionsModal()
            }
        } catch (error) {
            console.error("Upload failed:", error);
        }
    };

    const service_instration = () => {
        let url = localStorage.getItem('recoredURL')
        return {
            "delivery_tip": deliverytipamt,
            "delivery_instructions": selectedTexts,
            "additional_notes": consulation,
            "voice_note": url
        }
    }


    const [oldAudio, setOldAudio] = useState(null);
    const [isOldPlaying, setIsOldPlaying] = useState(false);

    useEffect(() => {
        if (oldRecordurl) {
            setOldAudio(new Audio(oldRecordurl));
        }
    }, [oldRecordurl]);

    const togglePlayOldAudio = () => {
        if (!oldAudio) return;

        if (isOldPlaying) {
            oldAudio.pause();
            oldAudio.currentTime = 0;
            setIsOldPlaying(false);
        } else {
            oldAudio.play();
            setIsOldPlaying(true);

            oldAudio.onended = () => {
                setIsOldPlaying(false);
            };
        }
    };

    const pageLoadedFunction = (status) => {
        setPageLoaded(status)
    }


    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' onClick={() => fromPage == "bookingManager" ? navigate(-1) : handelBack()} />
                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>{offerServiceRedeemStatus ? "Review & Redeem" : "Review & Pay"} </div>
                </div>
            </div>
            {
                pageLoaded ?
                    <div className='reviewAndPay offcanvas-parentType2'>
                        <div className='scroller-style-y cursorDefault'>
                            <div className='bg-white rounded-2 p-3'>
                                {/* <button onClick={() => openDoorReqModal()}>open</button> */}
                                {
                                    cartDetail.booking_service_type == '2' &&
                                    <>
                                        <div className='ff-poppins-semiBold fs-14'>
                                            Service Address
                                        </div>
                                        {cartDetail?.service_location_status ?
                                            <div onClick={() => getuserlocationlist()}>
                                                <div className="d-flex align-items-center border p-1 mt-4" style={{
                                                    opacity:
                                                        cartDetail?.service_location?.select_status == 0 ? 0.4 : 1,
                                                }}>
                                                    <div className="col-2">
                                                        <div className="border rounded w-100 border-black border-opacity-10 rounded d-flex justify-content-center fs-24 primary-text py-2">
                                                            {cartDetail?.service_location?.location_type_id == 1 ? (
                                                                <IoMdHome className="primary-text" />
                                                            ) : cartDetail?.service_location?.location_type_id == 2 ? (
                                                                <MdWork className="primary-text" />
                                                            ) : (
                                                                <IoLocationSharp />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-9">
                                                        <p className="m-0 ps-3 ff-poppins-bold">
                                                            {cartDetail?.service_location?.location_type}{" "}
                                                        </p>
                                                        <p className="m-0 ps-3 ff-poppins-regular singleline-text fs-12">
                                                            {cartDetail?.service_location?.address}
                                                        </p>
                                                        <p className='m-0 ps-3 ff-poppins-regular fs-12'>
                                                            {cartDetail?.service_location?.directions?.distance.text} - {cartDetail?.service_location?.directions?.duration.text}
                                                        </p>
                                                    </div>
                                                    <div className="col-1">
                                                        <IoIosArrowForward />
                                                    </div>
                                                </div>
                                            </div>
                                            : <button type='button' onClick={() => getuserlocationlist()} className={`btn-type-3 ff-poppins-medium fs-12 w-100 border bg-white text-dark mt-3 mb-3 text-center justify-content-center d-flex align-items-center`}>
                                                {!locationLoading ? 'Add Address' : <ReactLoading type={"spinningBubbles"} color={"#a1a1a1"} height={20} width={20} />}
                                            </button>
                                        }
                                    </>
                                }


                                <div className='ff-poppins-semiBold fs-12 mt-3 mb-3 pb-3'>
                                    {cartDetail.book_date_time}
                                </div>

                                <div>
                                    <div className='ff-poppins-semiBold fs-14'>
                                        Booking For
                                    </div>
                                    <div className='profileCard'>
                                        <div className='d-flex'>
                                            <img className='rounded-2' width={'56px'} height={'54px'} src={cartDetail.booking_for?.image} />
                                            <div className='ms-3 w-100'>
                                                <div className='ff-poppins-semiBold fs-14'>
                                                    {cartDetail.booking_for?.name}
                                                </div>
                                                <div className='ff-poppins-regular fs-12'>
                                                    {cartDetail.booking_for?.relationship}
                                                </div>
                                                <div className='ff-poppins-regular fs-12'>
                                                    {cartDetail.booking_for?.category_name}

                                                </div>
                                                {/* <div className='ff-poppins-regular fs-10'>
                                            {cartDetail.booking_for?.name} - {cartDetail.booking_for?.breed}
                                        </div> */}
                                                {/* <div className='ff-poppins-regular fs-10'>
                                        {cartDetail.booking_for?.name} - {cartDetail.booking_for?.breed}
                                    </div> */}
                                                {
                                                    cartDetail?.vendor_details?.vendor_type_id == '2' ?
                                                        <div className='ff-poppins-regular fs-12'>
                                                            {cartDetail.booking_for?.type} - {cartDetail.booking_for?.breed}
                                                        </div> :
                                                        <></>
                                                }
                                                {
                                                    showMoreInforUser
                                                        ?
                                                        <div>
                                                            {
                                                                cartDetail?.vendor_details?.vendor_type_id == '2' ?
                                                                    <div className='ff-poppins-regular fs-12 mb-1'>
                                                                        {cartDetail.booking_for?.gender} - {cartDetail.booking_for?.age} Years - {cartDetail.booking_for?.weight} Kg
                                                                    </div> : <></>
                                                            }

                                                            <div className='ff-poppins-regular fs-12 '>
                                                                {cartDetail.booking_for?.register_number}
                                                            </div>
                                                            <hr className='mt-1 mb-1' />
                                                            <div className='ff-poppins-regular text-center col-3 rounded-1 ff-poppins-regular temperamentBox fs-12 '>
                                                                {cartDetail.booking_for?.temperament}
                                                            </div>
                                                            <div className='ff-poppins-regular fs-12 '>
                                                                {cartDetail.booking_for?.about}
                                                            </div>

                                                            <div className='ff-poppins-semiBold fs-12 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforUser(!showMoreInforUser) }}>
                                                                Less info
                                                                <img
                                                                    src={p_up_arrow}
                                                                    width={'10px'}
                                                                    height={'7px'}
                                                                    alt='Show Less Info'
                                                                    role='button'
                                                                    className='ms-1'
                                                                />
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className='ff-poppins-semiBold fs-12 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforUser(!showMoreInforUser) }}>
                                                            More info
                                                            <img
                                                                src={p_down_arrow}
                                                                width={'10px'}
                                                                height={'7px'}
                                                                alt='Show Less Info'
                                                                role='button'
                                                                className='ms-1'
                                                            />
                                                        </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    cartDetail?.vendor_details?.staff_app_status == "1" && cartDetail?.booking_staff?.staff_id != "1" ?
                                        <div className='mt-4'>
                                            <div className='ff-poppins-semiBold fs-14'>
                                                Appointment with
                                            </div>
                                            <div className='profileCard'>
                                                <div className='d-flex'>
                                                    <img className='rounded-2' width={'56px'} height={'54px'} src={cartDetail.booking_staff?.staff_image} />
                                                    <div className='ms-3 w-100'>
                                                        <div className='ff-poppins-semiBold fs-14'>
                                                            {cartDetail.booking_staff?.staff_name}
                                                        </div>
                                                        <div className='ff-poppins-regular fs-12'>
                                                            {cartDetail.booking_staff?.staff_designation}
                                                        </div>
                                                        {
                                                            showMoreInforStaff
                                                                ?
                                                                <div>
                                                                    <div className='ff-poppins-regular fs-12 mb-1'>
                                                                        {cartDetail.booking_staff?.staff_specialist}
                                                                    </div>
                                                                    <hr className='mt-1 mb-1' />
                                                                    <div className='ff-poppins-regular fs-12 '>
                                                                        {cartDetail.booking_staff?.staff_about}
                                                                    </div>
                                                                    <div className='ff-poppins-semiBold fs-12 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforStaff(!showMoreInforStaff) }}>
                                                                        Less info
                                                                        <img
                                                                            src={p_up_arrow}
                                                                            width={'10px'}
                                                                            height={'7px'}
                                                                            alt='Show Less Info'
                                                                            role='button'
                                                                            className='ms-1'
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className='ff-poppins-semiBold fs-12 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforStaff(!showMoreInforStaff) }}>
                                                                    More info
                                                                    <img
                                                                        src={p_down_arrow}
                                                                        width={'10px'}
                                                                        height={'7px'}
                                                                        alt='Show Less Info'
                                                                        role='button'
                                                                        className='ms-1'
                                                                    />
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div> :
                                        <></>
                                }

                                {
                                    cartDetail?.applied_card_detail?.card_type == 'offer' || cartDetail?.applied_card_detail?.card_type == 'loyalty' ?
                                        <></>
                                        :
                                        <>
                                            <h6 className="ff-poppins-bold  fs-15 mt-3">Coupons</h6>
                                            <div className="secondary-box mb-1  d-flex justify-content-between align-items-center rounded-3 h-100" onClick={() => navigate(`/Coupon_list/${valueParam.vendor_id}`, { state: { cart_id: cartId, fromPage: "service" } })}>
                                                <div className="d-flex align-items-center mt-3 mb-3">
                                                    <img src={apply_coupon} height="16px" width="20px" className="mt-1 ms-2" />

                                                    <span className="fs-14 ms-2 mt-1 ff-poppins-semiBold">
                                                        {
                                                            cartDetail?.card_applied_status == 1 && cartDetail?.applied_card_detail.card_type == "coupon" ?
                                                                cartDetail.applied_card_detail.coupons_code : " Apply Coupon"
                                                        }
                                                    </span>
                                                    {
                                                        cartDetail?.card_applied_status == 1 && cartDetail?.applied_card_detail.card_type == "coupon" ?

                                                            <span className="fs-10 mt-1 rounded-4 text-center ms-2 ff-poppins-regular applied_lable">Applied</span> : ""

                                                    }

                                                </div>

                                                <div className="mt-2 mb-2 me-2 secondary-text-1  ff-poppins-regular fs-20">
                                                    <IoIosArrowForward />
                                                </div>
                                            </div>
                                        </>
                                }


                                {cartDetail && (Number(cartDetail.booking_service_type) == 2 && (Number(cartDetail.doorstep_request_status) == 2)) ?
                                    <div className="mt-3 cursorDefault">
                                        <div>
                                            <h5 className='fs-14 ff-poppins-medium'>Service Instructions</h5>
                                            <p className="text-center fs-11 p-0 m-0  ff-poppins-regular mt-2">Add service instructions for your service visit !</p>
                                            <div className=" d-flex  scroller-style-x ">
                                                <div className="d-flex mt-3 overflow-auto scroller-style-x">
                                                    {[
                                                        { id: 1, icon: bell_icon, label: "Don't ring the bell" },
                                                        { id: 2, icon: door_icon, label: "Handle with care" },
                                                        { id: 3, icon: Avoid_call, label: "Avoid calling" },
                                                        { id: 4, icon: pet_foot, label: "Pet at home" },

                                                    ].map((option) => (
                                                        <div
                                                            key={option.id}
                                                            className={`${instructionsOption.includes(option.label) ? "select-primary-box" : ""} Instructions-box mx-1`}
                                                            onClick={() => handleOptionToggle(option.label)}
                                                        >
                                                            {
                                                                typeof option.icon === "string" ? (
                                                                    <img src={option.icon} alt={option.label} className="instrctionIcons" />
                                                                ) : (
                                                                    <div className="icon-wrapper">{option.icon}</div>
                                                                )
                                                            }
                                                            <p className="fs-10 ff-poppins-semiBold p-0">{option.label}</p>
                                                        </div>
                                                    ))}
                                                </div>

                                            </div>

                                            {recordedAudio || consulation ?
                                                <div className="addedInstructionContainer d-flex justify-content-between align-center w-100 p-2 mt-1" onClick={() => openinstructionsModal()} >
                                                    <div className="addedInstrcRight d-flex  align-center gap-1">
                                                        <FaCircleCheck size={14} />
                                                        Instructions Added
                                                    </div>
                                                    <div className="addedInstrcRight">
                                                        Edit
                                                    </div>
                                                </div>
                                                :
                                                <div>
                                                    <p className="p-0 m-0 fs-12 ms-2 ff-poppins-semiBold mt-3 mb-3 primary-text" onClick={() => openinstructionsModal()}>+  Add an instructions note</p>
                                                </div>
                                            }
                                        </div>
                                    </div> : ""
                                }

                                {cartDetail && cartDetail.payment_options && (Number(cartDetail.booking_service_type) == 1 || (Number(cartDetail.booking_service_type) == 2 && (Number(cartDetail.doorstep_request_status) == 2))) && offerServiceRedeemStatus == '' ?

                                    // {cartDetail && cartDetail.payment_options && (Number(cartDetail.booking_service_type) == 1 || (Number(cartDetail.booking_service_type) == 2 && (Number(cartDetail.doorstep_request_status) == 2))) ?

                                    <div className='mt-4'>
                                        <div className='ff-poppins-semiBold fs-14'>Payment method</div>
                                        {
                                            cartDetail.payment_options?.online_payment == 1 &&
                                            <div class="d-flex justify-content-between align-items-center mt-2">
                                                <label class="form-check-label w-100 d-flex justify-content-between align-items-center" role='button' for="flexRadioDefault1">
                                                    <div>
                                                        <div className='ff-poppins-semiBold fs-12'>Pay Full </div>
                                                        <div className='ff-poppins-regular fs-10'>Pay total amount now  </div>
                                                    </div>

                                                    <input
                                                        class="form-check-input custom-radio1"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        id="flexRadioDefault1"
                                                        value="1"
                                                        checked={selectedPaymentOption === "1"}
                                                        onChange={handleOptionChange}
                                                    />

                                                    <span class="radio-icon"></span>
                                                </label>
                                            </div>
                                        }

                                        {
                                            cartDetail.payment_options?.advance_payment == 1 && cartDetail?.edit_service_status != 1 &&
                                            <div class="d-flex justify-content-between align-items-center mt-2">
                                                <label class="form-check-label w-100 d-flex justify-content-between align-items-center" role='button' for="flexRadioDefault2">
                                                    <div>
                                                        <div className='ff-poppins-semiBold fs-12'>Pay advance</div>
                                                        <div className='ff-poppins-regular fs-10'>Pay a merchant-determined amount upfront now.</div>
                                                    </div>

                                                    <input
                                                        class="form-check-input custom-radio1"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        id="flexRadioDefault2"
                                                        value="2"
                                                        checked={selectedPaymentOption === "2"}
                                                        onChange={handleOptionChange}
                                                    />

                                                    <span class="radio-icon"></span>
                                                </label>
                                            </div>
                                        }

                                        {
                                            cartDetail.payment_options?.cash_after_service == 1 && cartDetail?.edit_service_status != 1 &&
                                            <div class="d-flex justify-content-between align-items-center mt-2">
                                                <label class="form-check-label w-100 d-flex justify-content-between align-items-center" role='button' for="flexRadioDefault3">
                                                    <div>
                                                        <div className='ff-poppins-semiBold fs-12'>Cash after service</div>
                                                        <div className='ff-poppins-regular fs-10'>Pay in cash at the store after service completion.</div>
                                                    </div>

                                                    <input
                                                        class="form-check-input custom-radio1"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        id="flexRadioDefault3"
                                                        value="3"
                                                        checked={selectedPaymentOption === "3"}
                                                        onChange={handleOptionChange}
                                                    />

                                                    <span class="radio-icon"></span>
                                                </label>
                                            </div>
                                        }

                                    </div>
                                    : <></>
                                }

                                {
                                    showMoreInforBillingInfo
                                        ?
                                        <div
                                            className='border-bottom mt-3 pt-3' role='button'
                                            onClick={() => { setShowMoreInforBillingInfo(!showMoreInforBillingInfo) }}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='ff-poppins-semiBold fs-14 mb-2 primary-text'>
                                                    BILLING INFORMATION
                                                </div>
                                                <img src={p_up_arrow} width={'13px'} height={'7px'} alt='Show more Info' role='button' />
                                            </div>

                                            <div className='ff-poppins-regular  fs-12'>
                                                Booking Initiated at {cartDetail.book_initiate_time} by {
                                                    cartDetail?.booking_by_type == "vendor"
                                                        ? `${cartDetail?.booking_by} (${cartDetail?.vendor_details?.vendor_company_name})`

                                                        : cartDetail.booking_by
                                                } for {cartDetail.booking_for?.name}

                                            </div>
                                        </div>
                                        :
                                        <div role='button' className='d-flex align-items-center justify-content-between border-bottom mt-3 pt-3'
                                            onClick={() => { setShowMoreInforBillingInfo(!showMoreInforBillingInfo) }}>
                                            <div className='ff-poppins-semiBold primary-text fs-14 mb-2'>
                                                BILLING INFORMATION
                                            </div>
                                            <img src={p_down_arrow}
                                                width={'13px'}
                                                height={'7px'}
                                                alt='Show more Info'
                                                role='button' />
                                        </div>
                                }


                                {
                                    cartDetail?.card_applied_status && cartDetail?.applied_card_detail?.card_type && cartDetail?.applied_card_detail?.offer_type == 3 ?
                                        <>
                                            <div className='ff-poppins-semiBold primary-text fs-14 mt-2 pt-1 pb-1'>
                                                Buy Service{cartDetail.offer_details.buy_services.length > 1 ? 's' : ''}
                                            </div>
                                            <div>
                                                {
                                                    cartDetail && cartDetail.offer_details.buy_services && cartDetail.offer_details.buy_services.length > 0
                                                        ? cartDetail.offer_details.buy_services.map(item => {
                                                            return (
                                                                <div className='d-flex align-items-center mt-1 justify-content-between ff-poppins-regular fs-12 '>
                                                                    <span>{item.service_name}</span>
                                                                    <span>{item.service_price}.00</span>
                                                                </div>
                                                            )
                                                        }) : <></>
                                                }
                                            </div>
                                            <div className='charges pb-0 mt-1' >
                                                <div className='d-flex align-items-center justify-content-between ff-poppins-medium primary-text fs-12 mb-1'>
                                                    <span>Total (Offer Price)</span>
                                                    <span>Rs.{cartDetail.offer_details.buy_services_total ? cartDetail.offer_details.buy_services_total : '0.00'}</span>
                                                </div>
                                            </div>

                                            <div className='ff-poppins-semiBold primary-text fs-14 mt-2 pt-1 pb-1'>
                                                Get Service{cartDetail.offer_details.get_services.length > 1 ? 's' : ''}
                                            </div>
                                            <div>
                                                {
                                                    cartDetail && cartDetail.offer_details.get_services && cartDetail.offer_details.get_services.length > 0
                                                        ? cartDetail.offer_details.get_services.map(item => {
                                                            return (
                                                                <div className='d-flex align-items-center justify-content-between mb-1 ff-poppins-regular fs-12 '>
                                                                    <span>{item.service_name}</span>
                                                                    <span>{item.service_price}.00</span>
                                                                </div>
                                                            )
                                                        }) : <></>
                                                }
                                            </div>
                                            <div className='charges pb-0' style={{ borderBottom: 0 }}>
                                                <div className='d-flex align-items-center justify-content-between ff-poppins-medium primary-text fs-12 '>
                                                    <span>Total (Free Value)</span>
                                                    <span>Rs.{cartDetail.offer_details.get_services_total ? cartDetail.offer_details.get_services_total : '0.00'}</span>
                                                </div>
                                            </div>

                                        </> :
                                        <>
                                            <div className='ff-poppins-semiBold primary-text fs-14 mt-2 pt-1 pb-1'>
                                                Services
                                            </div>
                                            <div className='mb-2'>
                                                {
                                                    cartDetail.cart_services?.map(item => {
                                                        return (
                                                            <div className='d-flex align-items-center justify-content-between   ff-poppins-regular fs-12 '>
                                                                <span>{item.service_name}</span>
                                                                <span>{item.service_price}.00</span>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {
                                                cartDetail && cartDetail.discount_status == 1 ?
                                                    <div className='charges pb-0' style={{ borderBottom: 0 }}>
                                                        <div className='d-flex align-items-center justify-content-between ff-poppins-regular text-success fs-12 '>
                                                            <span>{cartDetail?.discount_detail?.lable}</span>
                                                            <span> {cartDetail?.discount_detail?.discount_amount}</span>
                                                        </div></div>
                                                    : <></>
                                            }
                                        </>}


                                <div className='charges mt-1'>

                                    {cartDetail?.card_applied_status && cartDetail?.applied_card_detail?.offer_type == 4 ?
                                        <div className='d-flex align-items-center justify-content-between ff-poppins-regular fs-12 '>
                                            <span className='text-success'>
                                                Subtotal (Offer Price)
                                            </span>
                                            <span className='text-success'>{Number(cartDetail?.applied_card_detail?.offer_price || 0).toFixed(2)}</span>
                                        </div> :
                                        <div className='d-flex align-items-center justify-content-between ff-poppins-regular fs-12 '>
                                            <span>
                                                Subtotal{" "}  {offerServiceRedeemStatus != "1" && cartDetail.payment_details?.GST_type && (
                                                    <>({cartDetail.payment_details.GST_type})</>)}
                                            </span>
                                            <span>{cartDetail.payment_details?.net_amount}</span>
                                        </div>
                                    }


                                    {offerServiceRedeemStatus != '1' &&
                                        <div className='d-flex align-items-center justify-content-between ff-poppins-regular  fs-12 '>
                                            <span>Platform charges</span>
                                            <span>{cartDetail.payment_details?.user_platform_charges}</span>
                                        </div>}
                                    {
                                        offerServiceRedeemStatus == '1' ?
                                            <div className='d-flex align-items-center justify-content-between ff-poppins-regular fs-12 '>
                                                <span>Pingle points redeemed ({loyaltyPoints})</span>
                                                <span>- {cartDetail.payment_details?.net_amount}</span>
                                            </div> :
                                            cartDetail.GST_status == 1 ?
                                                <div>
                                                    <div className='d-flex align-items-center justify-content-between ff-poppins-regular fs-12 '>
                                                        <span>SGST {cartDetail.payment_details?.SGST_percentage}</span>
                                                        <span>{cartDetail.payment_details?.SGST_amount}</span>
                                                    </div>
                                                    <div className='d-flex align-items-center justify-content-between ff-poppins-regular  fs-12 '>
                                                        <span>CGST {cartDetail.payment_details?.CGST_percentage}</span>
                                                        <span>{cartDetail.payment_details?.CGST_amount}</span>
                                                    </div>
                                                </div> : ""
                                    }

                                    {
                                        cartDetail.payment_details?.round_of != 0 ?
                                            <div className='d-flex align-items-center justify-content-between ff-poppins-regular  fs-12 '>
                                                <span>Round Off</span>
                                                <span>{cartDetail.payment_details?.round_of}</span>
                                            </div> : <></>
                                    }

                                </div>

                                {
                                    cartDetail?.edit_service_status == 1 ?
                                        <>
                                            <div className='ff-poppins-bold d-flex justify-content-between fs-14 mt-2 pt-1'>
                                                <span>Total</span><span>Rs.{cartDetail.payment_details?.total_amount}</span>
                                            </div>
                                            <div className='ff-poppins-bold primary-text text-end fs-14 mt-1 pt-1'>
                                                Paid - Rs.{cartDetail.edit_service_datails?.paid_amount}
                                            </div>
                                            {
                                                cartDetail?.edit_service_datails.refund_status == 1 ?
                                                    <div className='ff-poppins-bold text-end fs-14 mt-1 pt-1'>
                                                        To Refund - Rs.{cartDetail.edit_service_datails?.balance_amount}
                                                    </div> :
                                                    cartDetail?.edit_service_datails.pay_status == 1 ?
                                                        <div className='ff-poppins-bold text-end fs-14 mt-1 pt-1'>
                                                            To Pay - Rs.{cartDetail.edit_service_datails?.balance_amount}
                                                        </div> : ""
                                            }



                                        </>
                                        :
                                        cartDetail?.applied_card_detail?.offer_type == 4 ?
                                            <div className='ff-poppins-bold d-flex justify-content-between fs-14 mt-2 pt-1'>
                                                <span>Total</span><span>Rs.{getOfferType4Total().toFixed(2)}</span>

                                            </div> :
                                            offerServiceRedeemStatus == '' ?
                                                <div className='ff-poppins-bold d-flex justify-content-between fs-14 mt-2 pt-1'>
                                                    <span>Total</span><span>Rs.{amountToPay ? amountToPay : cartDetail.payment_details?.total_amount}</span>
                                                </div> : <></>
                                }
                                {
                                    offerServiceRedeemStatus == '1' &&
                                    <div className='ff-poppins-bold d-flex justify-content-between fs-14 mt-2 pt-1'>
                                        <span>Total</span><span>Rs.0</span>
                                    </div>
                                }

                                {
                                    selectedPaymentOption == "2" ?
                                        <div>
                                            <div className='d-flex justify-content-between ff-poppins-bold fs-14 m-0 primary-text'>
                                                <span>Advance amount</span>
                                                <span className='text-end'>Rs.{cartDetail?.payment_options?.advance_amount}</span>
                                            </div>
                                            <div className='d-flex justify-content-between ff-poppins-bold fs-14 m-0 primary-text'>
                                                <span>Balance amount</span>
                                                <span className='text-end'>Rs.{cartDetail?.payment_options?.balence_amount}</span>
                                            </div>
                                        </div> : <></>
                                }

                                <div className="mt-2 ">
                                    {
                                        offerServiceRedeemStatus ?
                                            <h6 className=" ff-poppins-medium  fs-10"><span className="fs-11 ff-poppins-medium primary-text">Note : </span> Loyalty points used for this redemption are non-refundable.</h6>
                                            :
                                            (selectedPaymentOption == 1 && cartDetail?.payment_options?.refund_status == 1) || (selectedPaymentOption == 2 && cartDetail?.payment_options?.advance_refund_status == 1) ?
                                                <h6 className=" ff-poppins-medium  fs-10"><span className="fs-11 ff-poppins-medium primary-text">Note :</span>  This booking may be cancelled with a refund subject to cancellation charges.</h6>
                                                :
                                                <h6 className=" ff-poppins-medium  fs-10"><span className="fs-11 ff-poppins-medium primary-text">Note :</span> This booking cannot be cancelled and are non-refundable once confirmed.</h6>
                                    }
                                </div>

                            </div>
                            {
                                cartDetail && (Number(cartDetail.booking_service_type)) == 1 || (Number(cartDetail.booking_service_type) == 2 && (Number(cartDetail.doorstep_request_status) == 2)) ?
                                    <PayNowOffCanvas
                                        isOpen={isPayNowOffCanvasOpen}
                                        toggleOffCanvas={openPaySuccessModal}
                                        paymentMethod={selectedPaymentOption}
                                        payAmount={selectedPaymentOption == '1' ? (cartDetail?.card_applied_status && cartDetail?.applied_card_detail?.offer_type == 4 ? getOfferType4Total().toFixed(2) : cartDetail.payment_details?.total_amount) :cartDetail?.payment_options?.advance_amount}
                                        getbookingId={(value) => setBooking_ID(value)}
                                        cartDetail={cartDetail}
                                        service_instration={service_instration}
                                        book_date_time={cartDetail.book_date_time}
                                        pageLoadedFunction={pageLoadedFunction}
                                    /> :
                                    <div className={`px-2 py-4`} style={{ width: '100%', backgroundColor: '#fff', borderTopLeftRadius: 20, borderTopRightRadius: 20, position: 'sticky', bottom: 0, marginTop: 10 }}>
                                        <div className="offcanvas-body small">
                                            {
                                                cartDetail && (Number(cartDetail.booking_service_type)) == 1 || (Number(cartDetail.booking_service_type) == 2 && (Number(cartDetail.doorstep_request_status) == 0)) ?
                                                    <>


                                                        <button
                                                            type='button'
                                                            // disabled={cartDetail?.service_location_status == 0 || isLoading}
                                                            className={`btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg text-white border-0  payNowBtn`}
                                                            onClick={() => cartDetail?.service_location_status == 0 ?
                                                                // toast("service address not added", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", })
                                                                showToast('Please add a service address to continue.')
                                                                : sent_doorstep_service_request()}
                                                            style={{ position: 'relative' }}
                                                        >
                                                            {isLoading && (
                                                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                                                    <ReactLoading type={'spinningBubbles'} color={'#fff'} height={'20px'} width={'20px'} />
                                                                </div>
                                                            )}
                                                            {!isLoading && 'Send Request'}
                                                        </button>
                                                    </>
                                                    :
                                                    <>
                                                        {/* <div className='toPay'>
                                                <span className='ff-poppins-regular fs-12 primary-text'>To Pay </span>
                                                <span className='ff-poppins-bold fs-12'>RS {cartDetail.payment_details?.total_amount}</span>
                                            </div> */}

                                                        <div className='row m-0'>
                                                            <div className='col-6 p-2'>
                                                                {/* <button type='button'
                                                            className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn'
                                                            onClick={() => ""}
                                                        >
                                                            Call
                                                        </button> */}
                                                                <a href={`tel:${cartDetail?.vendor_details?.vendor_mbl}`} className='text-decoration-none'>
                                                                    <button type='button' className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn'  >
                                                                        Call
                                                                    </button>
                                                                </a>


                                                            </div>
                                                            <div className='col-6 p-2'>
                                                                <button type='button'
                                                                    className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn'
                                                                    onClick={() => navigate(`/chat/${cartDetail?.vendor_details?.vendor_id}`)}
                                                                >
                                                                    Message
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    </div>
                            }

                        </div>





                        <div className={`modal fade`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={doorstepReqModalRef} data-bs-backdrop="false" style={{ backgroundColor: "#fff" }}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content modal-success" style={{ width: 300 }}>
                                    <div className="modal-body justify-content-center ">
                                        <div className='d-flex justify-content-center'>
                                            <img src={bookingconfirm_img} height="100px" width="130px" />
                                        </div>
                                        <div className="text-center ff-poppins-semiBold fs-16  primary-text mt-4">
                                            Sent Request
                                        </div>
                                        <div className="text-center ff-poppins-semiBold mt-4 fs-14 secondary-text">
                                            Your appointment request has been successfully sent. Please wait for the merchant’s acceptance.
                                        </div>
                                        <div className=' d-flex justify-content-center'>


                                            <button type="button" className="btn rounded-pill ff-poppins-semiBold col-6 primary-bg text-white rounded my-3" onClick={() => {
                                                localStorage.removeItem("serviceDetail");
                                                localStorage.removeItem("selectedServiceOption");
                                                localStorage.removeItem("appliedCard");
                                                closeDoorReqModal();
                                                // navigate('/', { replace: true })
                                                navigate("/")
                                            }} style={{ backgroundColor: '#4e26a3', color: 'initial' }}>
                                                OK
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            <div className="modal fade" tabindex="-1" ref={paymentSuccessModalRef} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ backgroundColor: "#fff" }}>
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content" style={{ maxWidth: 300 }}>
                                        <div className="modal-body text-center">
                                            <div>
                                                <Lottie animationData={SuccessLotie} loop={false} />
                                            </div>
                                            <div className="text-center ff-poppins-bold primary-text">
                                                Payment Success
                                            </div>
                                            <div className="text-center ff-poppins-semiBold fw-normal">
                                                Redirecting to the booking .
                                            </div>
                                            <div className="w-100 d-flex justify-content-center">
                                                <button
                                                    type="button"
                                                    className="btn okBtnRP col-3 ff-poppins-bold primary-bg text-white rounded my-3"
                                                    onClick={() => {
                                                        localStorage.removeItem("serviceDetail");
                                                        localStorage.removeItem("selectedServiceOption");
                                                        localStorage.removeItem("appliedCard");
                                                        closePaySuccessModal();
                                                        navigate(`/details/${booking_ID}`, { state: { fromPage: "ReviewPay" } });
                                                    }}
                                                    style={{ backgroundColor: '#4e26a3', color: 'initial' }}
                                                >
                                                    OK
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        }
                        <div className="offcanvas fade rounded-top cursorDefault scroller-style-y" tabIndex="-1"
                            ref={locationModalRef} style={{ maxHeight: '70vh', position: 'sticky' }}>
                            <div className="offcanvas-body small bg-light position-relative" >
                                <div className="d-flex justify-content-between">
                                    <div className="ff-poppins-semiBold">
                                        <h5>Choose address</h5>
                                    </div>
                                    <div onClick={() => closeLocationModal()}>
                                        <CgCloseO />
                                    </div>
                                </div>
                                <div>
                                    {userLocation?.saved_locations?.map((location, index) => {
                                        return (
                                            <div onClick={() => location.select_status ?
                                                select_Location(location.latlng) :
                                                toast(`Doorstep service  available only with in ${userLocation?.doorstep_service_distance}km`, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", })
                                            } >
                                                <div className="d-flex align-items-center mt-4"
                                                    style={{ opacity: location.select_status == 0 ? 0.4 : 1 }}  >
                                                    <div className="col-2">
                                                        <div className="border w-100 border-black border-opacity-10 rounded d-flex justify-content-center fs-24 primary-text py-2">
                                                            {location.location_type_id == 1 ? (
                                                                <IoMdHome className="primary-text" />
                                                            ) : location.location_type_id == 2 ? (
                                                                <MdWork className="primary-text" />
                                                            ) : (
                                                                <IoLocationSharp />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-9">
                                                        <p className="m-0 ps-3 ff-poppins-bold">
                                                            {location.location_type}
                                                        </p>
                                                        <p className="m-0 ps-3 ff-poppins-regular fs-12">
                                                            {location.address?.length > 35
                                                                ? `${location.address.slice(0, 35)}...`
                                                                : location.address}
                                                        </p>
                                                        <div className='ps-3'>
                                                            <p className='fs-12 ff-poppins-regular secondary-text-1 p-0 m-0' >{location?.distance?.text} {" "}  -  {location?.duration?.text}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-1">
                                                        <IoIosArrowForward />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div onClick={() => { navigate("/AddDeliveryAddress", { state: { fromPage: 'service' } }); }} >
                                    <div className="d-flex align-items-center mt-4">
                                        <div className="col-2">
                                            <div className="w-100  d-flex justify-content-center fs-24 primary-text py-2">
                                                <FaRegSquarePlus />
                                            </div>
                                        </div>
                                        <div className="col-9">
                                            <p className="m-0 ps-3 ff-poppins-bold primary-text">Add New Address</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                    </div >

                    :
                    <div className="skeleton-bg">

                        <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
                        <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
                        <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
                        <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
                        <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
                        <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />

                    </div>
            }

            <div
                className="offcanvas offcanvas-bottomm Chooseaddres rounded-2 main"
                tabIndex="-1"
                aria-labelledby="offcanvasBottomLabel"
                ref={instructionsNoteRef}
                style={{ maxHeight: "47vh", zIndex: 1045 }}
            >
                <div className="offcanvas-body small bg-light position-relative">
                    {/* Header */}
                    <div className="d-flex justify-content-between">
                        <h5 className="ff-poppins-semiBold fs-16 text-dark ">
                            Instructions Note
                        </h5>
                        {
                            !pauseicon &&
                            <div onClick={() => closeinstructionsModal()}>
                                <IoMdClose />
                            </div>
                        }
                    </div>

                    {/* Audio Section */}
                    <div>
                        <div
                            className={`w-100 ${!restartRecord ? "primary-border-1" : "secondary-border"
                                } rounded-2  p-1`}
                            style={{ height: "60px" }}
                        >
                            {restartRecord ? (
                                <div className="d-flex justify-content-between align-items-center p-1">
                                    {!pauseicon ? (
                                        <p className="fs-12 ms-1 p-0 m-0 ff-poppins-medium  ">  Click to record instructions  </p>
                                    ) : (
                                        <p className="fs-12 ms-1 p-0 m-1 ff-poppins-medium text-danger "> Recording... {formatTime(recordingTime)}   </p>
                                    )}

                                    {!pauseicon ? (
                                        <div
                                            className="fs-14 me-2 p-0 m-0 mb-1"
                                            style={{ width: "35px", height: "35px" }}
                                            onClick={() => {
                                                deleteRecordedAudio();
                                                setPauseicon(true);
                                            }}
                                        >
                                            <AudioRecorder
                                                onRecordingComplete={addAudioElement}
                                                recorderControls={recorderControls}
                                                showVisualizer={true}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            onClick={() => {
                                                setPauseicon(false);
                                                recorderControls.stopRecording();
                                            }}
                                            className="fs-18 primary-text me-3 mt-1"
                                        >
                                            <FaPause />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="d-flex justify-content-between align-items-center ">
                                    <div onClick={togglePlayAudio} className=" primary-text d-flex ms-3 mt-2">
                                        <div className="fs-12 mt-2"> {isPlaying ? <FaStop /> : <FaPlay />}</div>
                                        <p className="fs-14 p-0 m-0 primary-text ms-2 ff-poppins-medium mt-2">Instructions Recorded</p>
                                    </div>
                                    <div className="d-flex mt-2">
                                        <p className="fs-14 p-0 m-0 primary-text ff-poppins-medium mt-2"> 0:00 / {formatTime(recordingTime)}</p>
                                        <span className="ms-2 me-1 fs-20 text-danger" onClick={() => { deleteRecordedAudio(); setRestartRecord(true); }}>
                                            <MdDeleteOutline />
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Additional Note */}
                    <div>
                        <h6 className="fs-14 mt-3 ff-poppins-semiBold ">
                            Additional Note
                        </h6>
                        <textarea
                            className="textAreaRP text-dark ff-poppins-regular fs-13 mb-1"
                            placeholder="Type your instructions here..."
                            value={consulation}
                            maxLength={120}
                            onChange={(e) => {
                                if (e.target.value.length <= 120) {
                                    setConsulation(e.target.value);
                                }
                            }}
                        ></textarea>

                        <div className="d-flex justify-content-end ff-poppins-regular fs-13 mt-1 ">
                            {consulation?.length} / 120
                        </div>
                    </div>

                    {/* Save Button */}
                    <button
                        disabled={pauseicon == true}
                        className="InstructionsNoteSaveBtn"
                        onClick={() => handleSave()}
                    >
                        Save
                    </button>
                </div>
            </div>


            {showPaymentSuccessModal && (
                <div className="modal-backdrop show"></div>
            )
            }

            {
                showPaymentSuccessModal && (
                    <div className="modal justify-content-center" tabIndex="-1" style={{ display: 'block' }}>
                        <div className="modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className='ff-poppins-semiBold fs-1 primary-text text-center'>
                                        Attention!
                                    </div>
                                    <div className='ff-poppins-regular fs-14 text-center mt-2'>
                                        To proceed further you need to login/register and get access to all the features.
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center mt-1 mb-1' role='button' onClick={() => { localStorage.setItem('vendorUrl', location.pathname); navigate('/login', { state: { fromGuest: true } }); }}>
                                        <div className='loginBtn primary-bg text-center text-white p-1 ff-poppins-medium fs-16'>Login</div>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center' role='button' onClick={handlePaySuccessClose}>
                                        <div className='loginBtn text-center text-secondary p-1 ff-poppins-medium fs-16 secondary-bg-1 mt-2'>Close</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {isModalOpen && <div className="modal-backdrop fade show"></div>}



        </>
    )
}

export default ReviewAndPay